import React, { useState } from 'react';
import Popover from 'devextreme-react/popover';
import { RiskMeterDto } from '../../../../dtos/RiskMeterDto';
import { RiskMeterSliceDto } from '../../../../dtos/RiskMeterSliceDto';
import { getScoreColor, NOT_STARTED_COLOR } from '../utils/riskMeterColors';
import SliceTooltip from './SliceTooltip';
import './RiskMeter.css';

interface RiskMeterTableProps {
    data: RiskMeterDto;
}

export default function RiskMeterTable({ data }: RiskMeterTableProps) {
    const [hoveredSlice, setHoveredSlice] = useState<RiskMeterSliceDto | null>(null);
    const numberColumnStyle = { width: '80px', textAlign: 'center' as const };

    return (
        <>
            <table className="table table-bordered table-sm risk-meter-table">
                <thead>
                    <tr>
                        <th>Phase/Milestone</th>
                        <th style={numberColumnStyle}>Projected</th>
                        <th style={numberColumnStyle}>Actual</th>
                        <th style={numberColumnStyle}>Deviation</th>
                        <th style={numberColumnStyle}>Score</th>
                    </tr>
                </thead>
                <tbody>
                    {data.slices.map((slice, index) => (
                        <tr
                            key={index}
                            id={`risk-table-row-${index}`}
                            style={{ cursor: 'pointer' }}
                            onMouseEnter={() => setHoveredSlice(slice)}
                            onMouseLeave={() => setHoveredSlice(null)}
                        >
                            <td><strong>{slice.label}</strong></td>
                            <td style={{ textAlign: 'center' }}>{slice.projected}</td>
                            <td style={{ textAlign: 'center' }}>{slice.actual !== null && slice.actual !== undefined ? slice.actual : '-'}</td>
                            <td style={{ textAlign: 'center' }}>{slice.variance !== null && slice.variance !== undefined ? slice.variance : '-'}</td>
                            <td style={{
                                backgroundColor: slice.score !== null ? getScoreColor(slice.score) : NOT_STARTED_COLOR,
                                fontWeight: 'bold',
                                textAlign: 'center'
                            }}>
                                {slice.score !== null ? slice.score : '-'}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <p style={{ fontSize: '0.8em', color: '#666', marginTop: '4px' }}>
                Note: Projected, Actual, and Deviation columns are measured in months.
            </p>
            {data.slices.map((slice, index) => (
                <Popover
                    key={index}
                    target={`#risk-table-row-${index}`}
                    visible={hoveredSlice === slice}
                    position="right"
                >
                    <SliceTooltip slice={slice} />
                </Popover>
            ))}
        </>
    );
}
